// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_enum-bug-keys.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_enum-bug-keys.js
// module chunks = 6